import { render, staticRenderFns } from "./RouteListCreatedPage.vue?vue&type=template&id=72f0759a&scoped=true&"
import script from "./RouteListCreatedPage.vue?vue&type=script&lang=js&"
export * from "./RouteListCreatedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f0759a",
  null
  
)

export default component.exports